import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=10190a62"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=10190a62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports